import React from 'react';
import BlockContainer from './BlockContainer';
import TitleContainer from './TitleContainer';
import styles from './PageTwo.module.scss';

export default function PageTwo() {

    return (
        <div className={styles["container"]} id="pageTwo">
            <BlockContainer />
            <div className={styles["main-container"]}>
                <TitleContainer file={"./assets/page_2/2_title.png"} />
                <div className={styles["video-container"]}>
                    <video src="./assets/page_2/video.mp4" autoPlay muted loop controls />
                </div>
            </div>
        </div>
    )
}